import React from "react"

const SpinnerInTablet: React.FC<{
  searching: boolean
  inModal?: boolean
}> = ({ searching, inModal }) => {
  return (
    <div
      style={{
        left: inModal ? "0" : undefined,
      }}
      className={
        searching ? "spinner fade is-show tablet" : "spinner fade"
      }></div>
  )
}
export default SpinnerInTablet
